<!--suppress ALL -->
<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      {{squad.shortName}}
    </template>
    <template v-slot:nav_right v-if="isShowForSysOradmin" >
      <router-link class="bg_btn" :to="{path: '/scout/playerScoutOneData', query: {organUuid:squad.organUuid,youthUuid:squad.youthUuid,squadUuid:squad.uuid}}" >
        球员评价
      </router-link>
      <div class="squadDetail">
        <el-button type="primary" class="uploadBtn" style="margin-left:10px" @click="squadPlayerDataUpload" :disabled="downloadLoading" :loading="downloadLoading">导出球员评价</el-button>
      </div>
    </template>
    <div v-show="!isLoading" class="header_wrap">
      <img class="img" :src="squad.banner|| scoreImg" @error="imgError">
      <div class="info">
        <p>主教练：{{squad.chiefCoachName || '--'}}</p>
        <!-- <p>领队：{{squad.leaderName || '--'}}</p>+ -->
        <p>教练员团队：{{squad.coachTeamNum}} 人</p>
        <p>球员数量：{{squad.playerTeamNum}}</p>
        <p>2025年注册球员数量：{{isSignUpNum}} 人</p>
        <p>球员主要出生于：{{squad.playerBirthdayYear | year}}</p>
        <p :class="{ squadDissolve: squad.squadDissolve }">球队状态：{{squad.squadDissolve | squadDissolve}}</p>
      </div>
      <div v-if="editSquadShow.includes(userRole) && isCanEditData" class="btn" @click="editSquad=true">编辑球队</div>
    </div>
    <div v-show="!isLoading" class="scroll_wrap">
      <vue-scroll>
        <div class="coach_wrap">
          <div style="width: 100%; padding:0 16px">
            <el-row align="middle" :gutter="10">
                <el-col :span="13" class="title">
                  <img :src="teacher" alt="">
                  <span>教练</span>
                </el-col>
              <template v-if="isCanEditData">
                <el-col :span="6" v-if="userRole !=='leader' && userRole !=='coach'" style="">
                  <div class="bg_btn" @click="addType='coach';addVisible = true">从教练员管理中选择</div>
                </el-col>
                <el-col :span="5" v-if="userRole !=='leader' && userRole !=='coach'">
                  <div  class="bg_btn" @click="coachList()">添加新教练</div>
                </el-col>
<!--                <el-col :span="5" v-if="userRole !=='leader' && userRole !=='coach'">-->
<!--                  <div  class="bg_btn" @click="batchCoachAdd = true">批量添加新教练</div>-->
<!--                </el-col>-->
              </template>
            </el-row>
          </div>
          <div v-for="(item,index) in coaches" :key="index" class="item">
            <img :src="item.headImgUrl || person" alt="" @error="item.headImgUrl = person">
            <div class="info">
              <div><span class="name">{{item.idName}}</span><span>{{item.duty}}</span></div>
              <div>
                <span>教练等级：{{item.classLevel | coachClassLevel}}</span>
                <span>手机号：{{item.phone}}</span>
<!--              <span>工作类型：{{item.coachNature | coachNatureFilter}}</span>-->
              </div>
              <!--<div>-->
                <!--<span>教案数量：总数（{{item.privateLibraryNum + item.internalLibraryNum}}）</span>-->
                <!--<span>私有（{{item.privateLibraryNum}}）</span>-->
                <!--<span>内部（{{item.internalLibraryNum}}）</span></div>-->
            </div>
            <div
              v-if="userRole !=='player'"
              class="bg_btn"
              style="margin-right:17px"
              @click="userDetail('coach',item.uuid)">查看</div>
          </div>
          <yioks-empty
            v-if="coaches.length === 0"
            tips="暂时没有数据，请点击“从教练员管理中选择”或者点击“添加新教练”"
            h="150px"
            @callback="addType='coach';addCoach = true"></yioks-empty>
        </div>
        <div v-if="false" class="coach_wrap">
          <el-row align="middle">
            <el-col :span="19" class="title">
              <img :src="teacher" alt="">
              <span>领队</span>
            </el-col>
            <el-col :span="4">
              <div class="bg_btn" @click="addType='leader';addVisible = true" v-if="isCanEditData">调整球队领队</div>
            </el-col>
          </el-row>
          <div v-for="(item,index) in leaders" :key="index" class="item">
            <img :src="item.headImgUrl || person" alt="" @error="item.headImgUrl = person">
            <div class="info">
              <div><span class="name">{{item.idName}}</span></div>
              <div><span>姓名：{{item.gender}}</span><span>手机号：{{item.phone}}</span></div>
            </div>
            <div v-if="userRole !=='player'" class="bg_btn" @click="userDetail('leader',item.uuid)" >查看</div>
          </div>
          <yioks-empty v-if="leaders.length === 0" h="200px"></yioks-empty>
        </div>
        <div class="player_wrap">
          <div style="width: 100%; padding:0 16px">
            <el-row>
              <el-col :span="8" class="title">
                <img src="@/assets/images/home/player.png" alt="">
                <span>球员</span>
              </el-col>
              <template v-if="isCanEditData">
                <el-col :span="6" :style="userRole !=='player' && userRole !== 'coach' ? '' :'margin-left: 41%;'" style="padding-right: 10px;">
                  <div v-if="userRole !=='player'" class="bg_btn"
                       @click="adjust(squadUuid)">从球员数据中选择
                  </div>
                </el-col>
                <el-col :span="5" style="padding-right: 10px;">
                  <div v-if="userRole !=='player' && userRole !== 'coach'" class="bg_btn"
                       @click="isAddPlayer = true">添加新球员
                  </div>
                </el-col>
                <el-col :span="5">
                  <div v-if="userRole !=='player' && userRole !== 'coach'" class="bg_btn"
                       @click="batchPlayerAdd = true">批量添加新球员
                  </div>
                </el-col>
              </template>
            </el-row>
            <div class="item_wrap">
              <span>注：绿色代表2025年注册球员，红色代表非2025年注册球员</span>
              <el-row class="" style="width:100%">
                <el-col
                  :span="8"
                  v-for="(item,index) in players"
                  :key="index">
                  <div
                    class="item_box"
                    :class="userRole === 'player' ? 'noCursor': null">
                    <div class="position_wrap">
                      <div v-if="item.position" :class="{ position : item.isSignUp==='2' ,position_red : item.isSignUp==='1', 'text-over' :true}"
                           :title="item.position">{{item.position}}
                      </div>
                    </div>
                    <div class="item" @click="goPlayerDetail(item.uuid)">
                      <img :src="item.headImgUrl || person" alt=""
                           @error="item.headImgUrl = person">
                      <div>
                        <p>姓名：{{item.idName}} </p>
                        <p>性别：{{ item.gender}} </p>
                        <p>训练时长：{{parseInt(item.trainingTime / 60)}}小时
                          {{parseInt(item.trainingTime % 60)}}分钟</p>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>

            </div>
            <template v-if="userRole !== 'coach'">
              <yioks-empty
                v-if="players.length === 0"
                tips="暂时没有数据，"
                name="立即添加球员"
                h="150px"
                @callback="addType='player';isAddPlayer = true">
              </yioks-empty>
            </template>
            <template v-else>
              <yioks-empty
                v-if="players.length === 0"
                tips="暂时没有数据"
                h="150px"
                >
              </yioks-empty>
            </template>
          </div>
        </div>

        <div class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex">
              <img
                src="@/assets/images/common/report_logo.png"
                style="width: 0.25rem; height: 0.2rem"
                alt=""
              />
              训练计划
            </div>
            <div >
              <p style="cursor: pointer" class="yioks_btn" @click="moreData" v-if="plan && plan.length">
                更多
              </p>
            </div>
          </div>
          <div v-if="showList" class="table">
            <div class="table" v-if="plan && plan.length">
              <div class="thead">
                <div class="tr">
                  <div class="th seq"><strong>序号</strong></div>
                  <div class="th time"><strong>周时间段</strong></div>
                  <div class="th squadName"><strong>球队名称</strong></div>
                  <div class="th technicalProportion"><strong>技战术</strong></div>
                  <div class="th physicalQualityProportion"><strong>身体素质</strong></div>
                  <div class="th aheadTrainingAmount"><strong>训练负荷</strong></div>
                  <div class="th aheadTrainingAmount"><strong>周总课次</strong></div>
                  <div class="th trainingTime"><strong>训练总时长</strong></div>
                  <div class="th opt"><strong>操作</strong></div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div v-for="(item, index) in plan" :key="index" class="tr">
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td time" :title="$ok.date.formatDate(item.aheadTrainingStartTime)+'~'+$ok.date.formatDate(item.aheadTrainingEndTime)">
                          <p>{{ item.aheadTrainingStartTime | time }}~{{ item.aheadTrainingEndTime | time }}</p>
                        </div>
                        <div class="td squadName" :title="item.squadName">
                          <p>{{ item.squadName }}</p>
                        </div>
                        <div class="td technicalProportion">
                          <p>{{ item.technicalProportion || '0' }}%</p>
                        </div>
                        <div class="td physicalQualityProportion">
                          <p>{{ item.physicalQualityProportion || '0' }}%</p>
                        </div>
                        <div class="td aheadTrainingAmount">
                          <p>{{ item.aheadTrainingAmount }}</p>
                        </div>
                        <div class="td aheadTrainingAmount">
                          <template v-if="item.trainingNumber">
                            <p>{{ item.trainingNumber }}次</p>
                          </template>
                          <template v-else>
                            <p>--</p>
                          </template>
                        </div>
                        <div class="td trainingTime">
                          <template v-if="item.trainingTime">
                            <p>{{ parseInt(item.trainingTime / 60) }}时{{ parseInt(item.trainingTime % 60) }}分</p>
                          </template>
                          <template v-else>
                            <p>--</p>
                          </template>
                        </div>
                        <div class="td opt">
                          <p>
                            <span class="item" @click="goDetail(item.uuid,item.squadUuid,item.aheadTrainingStartTime,item.aheadTrainingEndTime,item.youthShortName)">日计划</span>
                            <br>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
          <yioks-empty v-if="empty" tips="暂时没有数据" class="h"></yioks-empty>
        </div>

        <div class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex">
              <img
                src="@/assets/images/common/report_logo.png"
                style="width: 0.25rem; height: 0.2rem"
                alt=""
              />
              比赛赛事
            </div>
            <div >
              <p style="cursor: pointer" class="yioks_btn" @click="moreDatareport" v-if="report && report.length">
                更多
              </p>
            </div>
          </div>
          <div v-if="showListreport" class="table">
            <div class="table" v-if="report && report.length">
              <div class="thead">
                <div class="tr">
                  <div class="th seq"><strong>序号</strong></div>
                  <div class="th reportName"><strong>赛事名称</strong></div>
                  <div class="th squadNowName"><strong>参赛球队</strong></div>
                  <div class="th reportTime"><strong>赛事时间</strong></div>
                  <div class="th changNum"><strong>场次</strong></div>
                  <div class="th mingResult"><strong>名次</strong></div>
                  <div class="th opt"><strong>操作</strong></div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div v-for="(item, index) in report" :key="index" class="tr">
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td reportName" :title="item.tournamentName">
                          <p>{{ item.tournamentName }}</p>
                        </div>
                        <div class="td squadNowName" :title="item.squadNowName">
                          <p>{{ item.squadNowName }}</p>
                        </div>
                        <div class="td reportTime" :title="$ok.date.formatDate(item.matchTime)+'~'+$ok.date.formatDate(item.endTime)">
                          <p>{{ item.matchTime | time }}至{{ item.endTime | time }}</p>
                        </div>
                        <div class="td changNum" :title="item.reportNum">
                          <p>{{ item.reportNum }}</p>
                        </div>
                        <div class="td mingResult">
                          <p>{{item.squadResult}}
                          </p>
                        </div>
                        <div class="td opt">
                          <p>
                            <span class="item" @click="goDetailReport(item.uuid)">查看</span>
                            <br>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
          <yioks-empty v-if="emptyreport" tips="暂时没有数据" class="h"></yioks-empty>
        </div>

        <div class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex">
              <img
                src="@/assets/images/common/report_logo.png"
                style="width: 0.25rem; height: 0.2rem"
                alt=""
              />
              比赛报告
            </div>
            <div >
              <p style="cursor: pointer" class="yioks_btn" @click="moreDataMatch" v-if="match && match.length">
                更多
              </p>
            </div>
          </div>
          <div v-if="showListmatch" class="table">
            <div class="table" v-if="match && match.length">
              <div class="thead">
                <div class="tr">
                  <div class="th seq"><strong>序号</strong></div>
                  <div class="th tournamentName"><strong>比赛名称</strong></div>
                  <div class="th matchTime"><strong>比赛时间</strong></div>
                  <div class="th reportNum"><strong>对手</strong></div>
                  <div class="th squadResult"><strong>比赛结果</strong></div>
                  <div class="th opt"><strong>操作</strong></div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div v-for="(item, index) in match" :key="index" class="tr">
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td tournamentName" :title="item.matchName">
                          <p>{{ item.matchName }}</p>
                        </div>
                        <div class="td matchTime" :title="$ok.date.formatDate(item.matchTime)+'~'+$ok.date.formatDate(item.endTime)">
                          <p>{{ item.matchTime | time }}</p>
                        </div>
                        <div class="td reportNum" :title="item.vs">
                          <p>{{ item.vs }}</p>
                        </div>
                        <div class="td squadResult">
                          <p>{{item.matchResult}}
                            ({{ item.goalScore }} : {{ item.goalConceded }})
                          </p>
                        </div>
                        <div class="td opt">
                          <p>
                            <span class="item" @click="goDetailMatch(item.uuid)">查看</span>
                            <br>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
          <yioks-empty v-if="emptymatch" tips="暂时没有数据" class="h"></yioks-empty>
        </div>


      </vue-scroll>
    </div>
    <yioks-loading v-if="isLoading"></yioks-loading>
    <template v-if="editSquad">
      <AddSquadDialog
        :addSquad.sync="editSquad"
        :isEdit="true"
        :squadUuid="squadUuid"
        @hideAddsquadDialog="hideAddsquadDialog"></AddSquadDialog>
    </template>
    <importantUser
      v-if="addVisible"
      :show="addVisible"
      :type="addType"
      @flag="(bool)=>{ addVisible = bool }"
      @getList="getSquadDetail"/>
    <template v-if="isAddPlayer">
      <AddPlayerDialog :visible.sync="addPlayerShow"
                       v-if="addPlayerShow"
                       :addPlayer.sync="isAddPlayer"
                       :defaultSelect="playerInfo"
                       @hideDialog="hideDialog"></AddPlayerDialog>
    </template>
    <template v-if="addCoach">
      <AddCoachDialog
          :defaultSelect="coachInfo"
          :addCoach.sync="addCoach"
          :organList="[]"
          :isEdit="false"
          @hideDialog="(bool) => {addCoach = bool;getSquadDetail();coachHideDialog()}"></AddCoachDialog>
    </template>

    <!-- 批量导入教练员 -->
    <el-dialog
      :visible.sync="batchCoachAdd"
      width="500px"
      :title="$t('bulkImportCoaches')"
      :close-on-click-modal="false"
      custom-class="yioks_alert2"
    >
      <el-form
        ref="batchInfo"
        :model="batchInfo"
        :rules="formRules"
        label-width="110px"
      >
        <el-form-item label="管理单位" prop="organUuid">
          <el-select
            v-model.trim="batchInfo.organUuid"
            style="width: 100%"
            placeholder="请选择管理单位"
          >
            <el-option
              :key="batchInfo.organUuid"
              :value="batchInfo.organUuid"
              :label="batchInfo.organShortName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位" prop="youthUuid">
          <el-select
            v-model.trim="batchInfo.youthUuid"
            style="width: 100%"
            placeholder="请选择管理单位后再选择单位"
          >
            <el-option
              :key="batchInfo.youthUuid"
              :value="batchInfo.youthUuid"
              :label="batchInfo.youthShortName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择球队" prop="squadUuid">
          <el-select
            v-model.trim="batchInfo.squadUuid"
            style="width: 100%"
            placeholder="请选择单位后再选择球队"
          >
            <el-option
              :key="batchInfo.squadUuid"
              :value="batchInfo.squadUuid"
              :label="batchInfo.squadName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <UploadFile
        v-if="batchCoachAdd"
        request="/api/zuxie/guozi/coach/Excel"
        :templateFile="coachTempUrl"
        templateFileName="批量导入教练员帐号模板文件.xlsx"
        @callBack="batchAddCoach"
      />
    </el-dialog>

    <!-- 批量导入球员 -->
    <el-dialog
      :visible.sync="batchPlayerAdd"
      width="500px"
      title="批量导入球员"
      :close-on-click-modal="false"
      custom-class="yioks_alert2"
    >
      <el-form
        ref="batchInfo"
        :model="batchInfo"
        :rules="formRules"
        label-width="80px"
      >
        <el-form-item label="管理单位" prop="organUuid">
          <el-select
            v-model.trim="batchInfo.organUuid"
            style="width: 100%"
            placeholder="请选择管理单位"
          >
            <el-option
              :key="batchInfo.organUuid"
              :value="batchInfo.organUuid"
              :label="batchInfo.organShortName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位" prop="youthUuid">
          <el-select
            v-model.trim="batchInfo.youthUuid"
            style="width: 100%"
            placeholder="请选择管理单位后再选择单位"
          >
            <el-option
              :key="batchInfo.youthUuid"
              :value="batchInfo.youthUuid"
              :label="batchInfo.youthShortName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择球队" prop="squad">
          <el-select
            v-model.trim="batchInfo.squadUuid"
            style="width: 100%"
            placeholder="请选择球队"
          >
            <el-option
              :key="batchInfo.squadUuid"
              :value="batchInfo.squadUuid"
              :label="batchInfo.squadName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <UploadFile
        v-if="batchPlayerAdd"
        templateFileName="批量导入球员帐号模板文件.xlsx"
        request="/api/zuxie/guozi/player/upload/excel"
        :templateFile="playerTempUrl"
        @callBack="batchAddPlayer"
      />
    </el-dialog>
    <yioks-tip
      :showTip="showPayCoach"
      tipMsg="新开通的教练员帐号试用期为三十天，请尽快点击右上角“教练员帐号开通”按钮进行支付费用后使用。"
      :confirmBtn="$t('iKnow')"
      @callback="payCoachConfirmCallback"
    />
  </SubContent>

</template>

<script>

import scoreImg from '@/assets/images/common/squad.png'
import teacher from '@/assets/images/home/teacher.png'
import person from '@/assets/images/common/person.jpg'
import squad from '@/api/squad'
import coach from "@/api/coach";
import player from "@/api/player";
import plan from "@/api/plan";
import match from "@/api/match";
import scout from "@/api/scout";
import { filterIdNumber,coachClassLevel } from '@/utils/yioks_filter'
import storage from '@/utils/storage'
import rulesMixin from "@/utils/formRules/rulesMixin";
import pay from "@/api/pay";
import mixinAppConfig from "@/mixin/mixinAppConfig";
import { downloadByJs } from "@/utils/commen";
export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent'),
    'AddSquadDialog': () => import('@/components/squad'),
    'importantUser': () => import('./important'),
    'AddCoachDialog': () => import('@/components/coach'),
    'AddPlayerDialog': () => import('@/components/player'),
    UploadFile: () => import("@/components/UploadFileSh"),
    // 'AddPlayerDialog': () => import('@/components/player/PlayerAdd')
  },
  filters: {
    filterIdNumber,
    coachNatureFilter(val) {
      let res = '';
      switch(val) {
        case 'part_time':
          res = '兼职';
          break;
        case 'full_time':
          res = '全职';
          break;
        default:
          res = '--';
          break;
      }
      return res
    },
    coachClassLevel,
    year(val){
      if (val){
        let year = new Date(val).getFullYear()
        return year + '年';
      } else{
        return '--'
      }
    },
    squadDissolve(val){
      if (val)
        return '已停止';
      else
        return '正常';
    },
  },
  mixins: [rulesMixin,mixinAppConfig],
  data () {
    return {
      player: '',
      teacher,
      scoreImg,
      person,
      userRole: storage.get('userInfo').userRole,
      editSquad: false,
      editSquadShow: ['system', 'admin', 'youth', 'organ'],
      nameList: [],
      centerList: [],
      leaderList: [],
      squadUuid: this.$route.query.uuid,
      coaches: [],
      players: [],
      plan: [],
      match: [],
      report: [],
      squad: {},
      isSignUpNum: 0,
      isLoading: true,
      leaders: [],
      addVisible: false,
      isAddPlayer: false,
      addCoach: false,
      addCoachShow: false,
      addPlayerShow: false,
      showPayCoach: false,
      showList: false,
      showListmatch: false,
      showListreport: false,
      empty: false,
      emptymatch: false,
      emptyreport: false,
      playerInfo: {
        organUuid: '',
        squadUuid: '',
        youthUuid: ''
      },
      // 教练员
      coachInfo: {
        organUuid: '',
        squadUuid: '',
        youthUuid: ''
      },
      batchInfo: {
        organUuid: "",
        organShortName: "",
        youthShortName: "",
        youthUuid: "",
        squadUuid: "",
        squadName: ""
      },
      batchCoachAdd: false,
      batchPlayerAdd: false,
      addType: 'coach',
      downloadLoading:false,
    }
  },
  created () {
    this.getSquadDetail();
  },
  methods: {
    moreData() {
      this.$router.push({
        path: "/plan/list",
        query: {
          squadUuid: this.playerInfo.squadUuid,
          organUuid: this.playerInfo.organUuid,
          youthUuid: this.playerInfo.youthUuid,
          youthShortName: this.batchInfo.youthShortName,
        },
      });
    },
    moreDataMatch() {
      this.$router.push({
        path: "/match/list",
        query: {
          squadUuid: this.playerInfo.squadUuid,
          organUuid: this.playerInfo.organUuid,
          youthUuid: this.playerInfo.youthUuid,
          youthShortName: this.batchInfo.youthShortName,
        },
      });
    },
    moreDatareport() {
      this.$router.push({
        path: "/match/list_tournament",
        query: {
          squadUuid: this.playerInfo.squadUuid,
          organUuid: this.playerInfo.organUuid,
          youthUuid: this.playerInfo.youthUuid,
          youthShortName: this.batchInfo.youthShortName,
        },
      });
    },
    goDetail(aheadTrainingUuid,squadUuid,aheadTrainingStartTime,aheadTrainingEndTime,youthShortName) {
      this.$router.push({
        path: "/training/list",
        query: {
          aheadTrainingUuid,
          squadUuid,
          aheadTrainingStartTime,
          aheadTrainingEndTime,
          youthShortName,
        },
      });
    },
    goDetailMatch(uuid) {
      this.$router.push({
        path: "/match/detail",
        query: {
          uuid
        },
      });
    },
    goDetailReport(uuid) {
      this.$router.push({
        path: "/match/detailTournament",
        query: {
          uuid
        },
      });
    },
    getplanList() {
      this.showList = false;
      let request;
      if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") { // 系统管理员获取列表
        request = plan.getPlanSystem;
      } else if (this.userRole === "organ") { // 会员协会获取列表
        request = plan.getPlanListOrgan;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) { // 俱乐部获取列表
        request = plan.getPlanListYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") { // 教练获取列表
        request = plan.getPlanLeaderOrCoach;
      }
      let data = {
        page: 0,
        size: 5,
        squadUuid: this.playerInfo.squadUuid,
        organUuid: this.playerInfo.organUuid,
        youthUuid: this.playerInfo.youthUuid,
      };
      request(data)
      .then((res) => {
        this.total = res.totalElements;
        if (res.content.length) {
          this.plan = res.content;
          this.showList = true;
          this.empty = false;
        } else {
          this.empty = true;
        }
      })
      .catch((err) => {
        this.loading = false;
        console.error(err);
      });
    },
    getmatchList() {
      this.showListmatch = false;
      let data = {
        page: 0,
        size: 5,
        squadUuid: this.playerInfo.squadUuid,
        organUuid: this.playerInfo.organUuid,
        youthUuid: this.playerInfo.youthUuid,
      };
      let request;
      if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = match.getMatchReportListSystem;
      } else if (this.userRole === "organ") {
        request = match.getMatchReportListOrgan;
      } else if (this.userRole === "youth" || this.userRole === "trainCamp" || this.userRole === "club"
      ) {
        request = match.getMatchReportListYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = match.getMatchReportListCoach;
      }
      request(data)
      .then((res) => {
        this.total = res.totalElements;
        if (res.content.length) {
          this.match = res.content;
          this.showListmatch = true;
          this.emptymatch = false;
        } else {
          this.emptymatch = true;
        }
      })
      .catch((err) => {
        this.loading = false;
        console.error(err);
      });
    },
    getreportList() {
      this.showListreport = false;
      let data = {
        page: 0,
        size: 5,
        squadUuid: this.playerInfo.squadUuid,
        organUuid: this.playerInfo.organUuid,
        youthUuid: this.playerInfo.youthUuid,
      };
      let request;
      if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = match.getMatchReportListSystemTournament;
      } else if (this.userRole === "organ") {
        request = match.getMatchReportListOrganTournament;
      } else if (this.userRole === "youth" || this.userRole === "trainCamp" || this.userRole === "club"
      ) {
        request = match.getMatchReportListYouthTournament;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = match.getMatchReportListCoachTournament;
      }
      request(data)
        .then((res) => {
          this.total = res.totalElements;
          if (res.content.length) {
            this.report = res.content;
            this.showListreport = true;
            this.emptyreport = false;
          } else {
            this.emptyreport = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    hideDialog (val) {
      this.isAddPlayer = val
      this.getSquadDetail()
    },
    coachHideDialog (val) {
      this.showPayCoach = true;
      this.getRenewYouthNum();
    },
    goPlayerDetail (uuid) {
      if (this.userRole === 'player') return
      this.$router.push({
        path: '/player/info',
        query: {
          uuid
        }
      })
    },
    getSquadDetail () {
      let squadInfo = squad.getSquadInfo
      if (this.userRole === 'coach' || this.userRole === 'leader') {
        squadInfo = squad.getSquadInfoCoach
      } else if (this.userRole === 'player') {
        squadInfo = squad.getSquadInfoPlayer
      }
      squadInfo(this.squadUuid).then(res => {
        this.coaches = res.coaches
        this.players = res.players
        this.leaders = res.leaders
        this.squad = res.squad
        this.squadUuid = res.squad.uuid
        this.isSignUpNum = res.isSignUpNum
        this.$set(this.playerInfo, 'organUuid', res.squad.organUuid)
        this.$set(this.playerInfo, 'youthUuid', res.squad.youthUuid)
        this.$set(this.playerInfo, 'squadUuid', res.squad.uuid)
        this.$set(this.coachInfo, 'organUuid', res.squad.organUuid)
        this.$set(this.coachInfo, 'youthUuid', res.squad.youthUuid)
        this.$set(this.coachInfo, 'squadUuid', res.squad.uuid)
        this.$set(this.batchInfo, 'organUuid', res.squad.organUuid)
        this.$set(this.batchInfo, 'youthUuid', res.squad.youthUuid)
        this.$set(this.batchInfo, 'squadUuid', res.squad.uuid)
        this.$set(this.batchInfo, 'organShortName', res.squad.organShortName)
        this.$set(this.batchInfo, 'youthShortName', res.squad.youthShortName)
        this.$set(this.batchInfo, 'squadName', res.squad.squadName)
        this.isLoading = false
        this.addCoachShow = true
        this.addPlayerShow = true
        this.getplanList();
        this.getreportList();
        this.getmatchList();
      }).catch(err => {
        this.isLoading = false
        console.error(err)
      })
    },
    hideAddsquadDialog (flag) {
      this.editSquad = flag
      this.getSquadDetail()
    },
    adjust (uuid) {
      this.$router.push({
        path: 'adjust',
        query: {
          uuid
        }
      })
    },
    userDetail (from, uuid) {
      this.$router.push({
        path: `/${from}/info`,
        query: {
          uuid
        }
      })
    },
    coachList () {
      this.$router.push({
        path: `/coach/list`,
        query: {
          youthUuid: this.playerInfo.youthUuid,
          organUuid: this.playerInfo.organUuid
        }
      })
    },
    batchAddCoach(url,coachNum) {
      this.$refs["batchInfo"].validate((valid) => {
        if (valid) {
          let data = {
            coachToSquads: [this.batchInfo],
            path: url,
            coachNum: coachNum,
          };
          coach.batchAddCoach(data).then((res) => {
            this.batchCoachAdd = false;
            if(res.code){
              this.$message.error(res.msg);
            }else{
              this.showPayCoach = true;
              this.$message.success("导入成功");
              this.getSquadDetail();
              this.getRenewYouthNum();
            }
          });
        }
      });
    },
    batchAddPlayer(url) {
      this.$refs["batchInfo"].validate((valid) => {
        if (valid) {
          let data = {
            ...this.batchInfo,
            path: url,
            playerToSquads: [
              this.batchInfo,
            ]
          };
          player.batchAddLeader(data).then((res) => {
            this.$message.success("导入成功");
            this.batchPlayerAdd = false;
            this.getSquadDetail();
          });
        }
      });
    },
    imgError () {
      this.$set(this.squad, 'banner', this.scoreImg)
      this.isLoading = false
    },
    // 添加教练员提示
    payCoachConfirmCallback(isSure) {
      this.showPayCoach = false;
    },
    // 获取俱乐部开通教练员数量
    getRenewYouthNum() {
      if(this.userRole === 'youth' || this.userRole === 'club'){
        pay.getRenewYouthNum().then((res) => {
          storage.set('renewYouthNum', Number(res)||0);
          this.$store.commit("setRenewYouthNum");
        });
      }
    },
    squadPlayerDataUpload(){
      this.downloadLoading = true;
      scout.scoutPlayerDataUpload(this.squadUuid).then(res=>{
        if (res.code) {
          this.downloadLoading = false;
          this.$message.error(res.msg);
          return;
        }
        this.downloadLoading = false;
        const { fileName, filePath} = res;
        const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
        downloadByJs(transferPath, fileName);


      })
    },
  },
  computed: {
    isShowForSysOradmin() {
      return this.userRole === "system" || this.userRole === "admin";
    },
    coachTempUrl() {
      const clubConfig = this.$store.getters.sysHostType;
      if (clubConfig === "club") {
        return "/uploads/templateFile/coachClub.xlsx";
      } else {
        return "/uploads/templateFile/coach.xlsx";
      }
    },
    playerTempUrl() {
      const clubConfig = this.$store.getters.sysHostType;
      if (clubConfig === "club") {
        return "/uploads/templateFile/playerClub.xlsx";
      } else {
        return "/uploads/templateFile/player.xlsx";
      }
    },
  },
  watch: {
    batchCoachAdd(val) {
      if (!val) {
        // this.batchInfo = {
        //   organUuid: '',
        //   organShortName: '',
        //   youthShortName: '',
        //   youthUuid: ''
        // }
        // this.batchCenterList = []
        this.$refs["batchInfo"].resetFields();
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .header_wrap
    display flex
    align-items center
    font-size 18px
    border-bottom 1px solid #FFF
    padding-bottom 10px
    margin 20px 20px 0 20px
    img
      width 80px
      margin-right 20px
      margin-left 10px
    .info
      flex 1
      p
        margin-bottom 10px
        &:last-child
          margin-bottom 0
      .squadDissolve
        color #f88594 !important
    .btn
      border 1px solid #FFF
      padding 10px 16px
      margin-right 18px
      cursor pointer
      &:hover
        background #5ac8fa
  .scroll_wrap
    height 420px
    .info_item
      margin 0 30px 30px 10px
      padding: 0px 16px;
      .info_title
        font-size 20px
        padding 10px 0 20px
        display flex
        align-items center
        img
          margin-right 10px
          width 26px
      .table
        display flex
        flex-direction column
        flex 1
        width 100%
        // margin: 30px 0 0;

        .thead, .tbody
          border 1px solid $color_white

        .thead
          .tr
            height 45px
            display flex
        .scrollArea
          max-height 250px
          padding-bottom 15px
        .tbodyWrap
          display block
        .tbody
          display block
          width 818px
          border-top none
          border-bottom none
          .tr
            height 49px
            display flex
            border-bottom 1px solid $color_white
        .th, .td
          height 100%
          /* flex: 1 1 auto; */
          display flex
          justify-content center
          align-items center
          text-align center
          font-size $font_size_medium
          border-right 1px solid $color_white
        .th:last-child, .td:last-child
          border-right none
        .td
          p
            white-space nowrap
            overflow hidden
            text-overflow ellipsis
            color $color_white
        .technicalProportion
          width 8%
        .physicalQualityProportion
          width 9%
          p {
            padding 0 4px
          }
        .seq
          width 5%
        .squadName
          width 18%
        .aheadTrainingAmount
          width 9%
        .trainingTime
          width 11%
        .time
          width 22%
        .opt
          width 10%
          p
            width 100%
            text-align center
            .item
              cursor pointer
              user-select none
              color $green_color
            .split
              margin 0 5px
        .tournamentName
          width 40%
        .reportName
          width 35%
        .squadNowName
          width 18%
        .matchTime
          width 15%
        .reportTime
          width 25%
        .reportNum
          width 16%
        .changNum
          width 6%
        .squadResult
          width 11%
        .mingResult
          width 6%

    .title
      display flex
      align-items center
      img
        width 30px
        margin-right 5px
    .el-row
      padding 20px 0 0
    .coach_wrap
      /*margin-left 20px*/
      width 890px
      padding 0 20px
      .el-row
        height 90px
      .item
        width 100%
        border-bottom 1px solid #FFF
        display flex
        align-items center
        padding 20px 0
        margin-right 20px
        img
          width 90px
          height 90px
          border-radius 50%
          margin-right 20px
        .yioks_btn
          margin-right 20px
          padding 10px 35px
        .info
          flex 1
          .name
            font-size 20px
          div
            margin-bottom 8px
            &:first-child
              margin-bottom 15px
              display flex
              span
                line-height 20px
            span
              padding-right 20px
    .player_wrap
      margin-left 20px
      width 850px
      .item_wrap
        display flex
        flex-wrap wrap
        margin-top 20px
        .item_box
          margin-right 10px
          margin-bottom 10px
          cursor pointer
          .position_wrap
            min-height 22px
            .position
              /*background url('~@/assets/images/common/class_bg.png') no-repeat*/
              padding 2px
              background-color $green_color !important
            .position_red
              /*background url('~@/assets/images/common/class_bg.png') no-repeat*/
              padding 2px
              background-color $red_color !important
            .text-over
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
          .item
            border 1px solid #FFF
            display flex
            align-items center
            padding 10px 5px
            &:hover
              background url('~@/assets/images/common/hover_white.png') no-repeat right center
              background-size 82px 120px
            img
              width 55px
              border-radius 50%
              margin-right 5px
            p
              margin-bottom 5px
        .noCursor
          cursor default
          .item
            &:hover
              background unset
.bg_btn
  border 1px solid #fff
  padding 10px 16px
  text-align center
  cursor pointer
  &:hover
    background #5ac8fa
.uploadBtn
  border 1px solid #fff
  padding 10px 16px
  text-align center
  cursor pointer
  background none
  &:hover
    background #5ac8fa

.img
  width 80px
  height 80px
</style>
<style lang="stylus">
  .squadDetail
    .el-button
      font-size 18px
      border-radius 0px
      height 43px
</style>
